module.exports = __webpack_public_path__ + "img/banner_itemthr_topimg.fc37fdf6.png";